import React, { Component } from 'react';
import BsySwitchBtn from "../BsySwitchBtn";
import BsyIconBtn from "../BsyIconBtn";
import BsySearchInput from "../BsySearchInput";
import BsyTableList from "../BsyTableList";
import BsyDialog from "../BsyDialog";
import BsyAlert from "../BsyAlert";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlertQYWorkConfig from "../BsyAlertQYWorkConfig";
import { BsyUtils } from "../../utils/Utils";
import BsyAlertListDetail from "../BsyAlertListDetail";
import BsyAlertHandover from "../BsyAlertHandover";
import BsyAlertMenu from "../BsyAlertMenu";
import AddCorpCoopPane from "../BsyCorpCoop/AddCorpCoopPane";

class BsyResignCont extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userCont: {},
            deptId: null,
            hasCount: true,
            limit: 20,
            skip: 0,
            filter: "",
            departments: props.departments,
        }
    }

    skipChange = (val) => {
        this.setState({ skip: val }, () => {
            this.RefreshList()
        })
    }

    listLimitChange = (val) => {
        this.setState({ limit: val }, () => {
            this.RefreshList()
        })
    }

    listFilterChange = (val) => {
        this.setState({ filter: val }, () => {
            this.RefreshList()
        })
    }

    deptRefresh = (val) => {
        this.setState({ deptId: val }, () => {
            this.RefreshList()
        })
    }

    componentDidMount() {
        this.RefreshList();
    }

    onSearch = () => {
        const { deptId, hasCount, limit, skip } = this.state
        const filter = this.searchValue.getValue()
        React.axios('/corp/member/dismission_list', {
            deptId: deptId,
            filter: filter,
            hasCount: hasCount,
            limit: limit,
            skip: skip * limit
        }).then(res => {
            this.setState({ userCont: res.data })
        }).catch(res => {

        })
    }

    RefreshList = () => {
        const { hasCount, limit, skip, filter } = this.state
        React.axios('/corp/member/dismission_list', {
            hasCount: hasCount,
            filter: filter,
            limit: limit,
            skip: skip * limit
        }).then(res => {
            this.setState({ userCont: res.data })
        }).catch(res => {

        })
    }

    getSearchValue = (ref) => {
        this.searchValue = ref
    }

    getTableValue = (rel) => {
        this.tableValue = rel
    }

    switchChange = (val) => {
        if (window.FX.STATIC.user_corps.mode === "qyweixin") {
            if (val) {
                BsyAlertQYWorkConfig({
                    title: React.language('weChat.contacts.auth.title'),
                    styleCss: {
                        width: 966,
                        height: 500
                    }
                })
            }

            React.axios('/corp/set_name_modify', {
                status: val
            }).then(res => {

            }).catch(res => {

            })
        } else if (window.FX.STATIC.user_corps.mode === "dingding") {
            React.axios('/dingding/call_back_addressbook', {
                status: val
            }).then(res => {
                const { params } = res.data;
                if(params && !BsyUtils.isObjectEmpty(params)){
                    BsyDialog({
                        title: React.language('config.info'),
                        height: 360,
                        width: 650,
                        noFooter: true,
                        onContentCreate: () => {
                            return <div className="dingdingCallBackInfo">
                                <div className="infoTitle">在 开发管理-{">"}事件订阅 中配置推送参数</div>
                                <div className="infoList">
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('push.method')}</div>
                                        <div className="infoItemValue">HTTP推送</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('encryption.aes_key')}</div>
                                        <div className="infoItemValue">{params.aes_key}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('signature.token')}</div>
                                        <div className="infoItemValue">{params.token}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('request.URL')}</div>
                                        <div className="infoItemValue">{params.url}</div>
                                    </div>
                                    <div className="infoItem">
                                        <div className="infoItemTitle">{React.language('event.subscription')}</div>
                                        <div className="infoItemValue">开启所有的通讯录事件</div>
                                    </div>
                                </div>
                            </div>
                        }
                    })
                }
            }).catch(res => {

            })
        } else if (window.FX.STATIC.user_corps.mode === "fugou") {
            React.axios('/fugou/call_back_addressbook', {
                status: val
            }).then(res => {

            }).catch(res => {

            })
        } else if (window.FX.STATIC.user_corps.mode === "feishu") {
            React.axios('/feishu/call_back_addressbook', {
                status: val
            }).then(res => {

            }).catch(res => {

            })
        } else {
            React.axios('/corp/set_name_modify', {
                has_name_modify: val
            }).then(res => {

            }).catch(res => {

            })
        }
    }

    qywechatConfig = () => {
        BsyAlertQYWorkConfig({
            title: React.language('weChat.contacts.auth.title'),
            styleCss: {
                width: 966,
                height: 500
            }
        })
    }

    _createChangOutsiderBubble = (b) => {
        if (!b || b.length <= 0)
            return void tipAlert({
                type: "warning",
                msg: React.language("move.tip")
            });
        let that = this;
        const d = new window.FX.ConfirmDialog({
            title: React.language("member.select.list"),
            height: 576,
            width: 710,
            contentWidget: {
                rowSize: [440],
                colSize: [680],
                padding: 15,
                items: [[{
                    widgetName: "memberSelect",
                    type: "memberselectpane",

                    radioEnable: !0,
                    checkEnable: !1,
                    memberEnable: !1,
                    departmentEnable: !1,
                    outsiderMemberEnable: !1,
                    // outsiderGroupEnable:!1,
                    roleEnable: !1,
                    dynamicEnable: !1,
                    dynamicType: "set"
                }]]
            },
            onOk: function () {
                var dept = d.getWidgetByName("memberSelect")
                var d1 = dept.getAllJsonValue();
                if (!d1) {
                    return;
                }

                if (d1.outsiderGroup.length == 0) {
                    return
                }

                React.axios("/corp/member/transfer", {
                    user_id: b,
                    group_id: d1.outsiderGroup[0],
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        that.RefreshList();
                        d.close()
                    })

                }).catch(res => {

                })
                return !1;
            }
        });
        d.show()
    }

    recover = (id) => {
        if (id.length <= 0) {
            tipAlert({
                type: "warning",
                msg: React.language('resign.user.tip')
            })
            return
        }
        BsyAlert({
            title: React.language("resign.alert.tip"),
            // msg: "",
            type: "query",
            text4Ok: React.language("ok"),
            OkType: "blue",
            text4Cancel: React.language("cancel"),
            ok: () => {
                React.axios('/corp/member/recover', {
                    "members": id
                }).then((res) => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        this.RefreshList()
                    })
                }).catch(() => {

                })
            }
        })
    }

    memberRowClick = (event, item) => {
        // console.log(item)
        if (event.target.classList[0] === "icon-flow-other" || event.target.classList[0] === "menuTd") {

            let menu = [{
                text: React.language('edit'),
                colorType: "",
                click: () => {
                    //     this.removeAlert()
                    item["mode"] = "resign"
                    BsyAlertListDetail({
                        ...item,
                        departments: this.state.departments,
                        onReList: () => {
                            this.RefreshList()
                        }
                    })
                    document.getElementsByTagName('body')[0].style.overflow = "hidden"
                }
            }];
            if (item.category !== -1) {
                menu.push({
                    text: React.language('handover.work'),
                    colorType: "",
                    click: () => {
                        // this.removeAlert()
                        // BsySliderHandover({
                        //     userInfo:item,
                        //     title:React.language('handover.work')
                        // })
                        BsyAlertHandover({
                            userInfo: item,
                            title: React.language('handover.work'),
                            styleCss: {
                                width: "966px",
                                height: "582px",
                                maxHeight: "calc(100% - 100px)"
                            },
                            onClose: () => {
                                this.RefreshList()
                            }
                        })
                    }
                })
            }
            if (item.status === -2) {
                menu.push({
                    text: React.language('reinstatement'),
                    colorType: "",
                    click: () => {
                        this.recover([item._id]);
                    }
                })
            }
            if ((item.category === -1 || item.category === -2) && BsyUtils.isCommon()) {
                menu.push({
                    text: React.language('delete.hard'),
                    colorType: "red",
                    click: () => {
                        const { _id } = item;
                        //     this.removeAlert()
                        BsyAlert({
                            title: React.language("del.tip1"),
                            msg: '',
                            type: "warning",
                            text4Ok: React.language("delete.hard"),
                            OkType: "red",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                React.axios("/manager/team/" + window.FX.Utils.getCurrentCorp() + "/delete", {
                                    members: [_id], // 成员ID
                                    department_id: 1 //部门ID，1表示全部成员下
                                }).then(res => {
                                    tipAlert({
                                        type: "success",
                                        msg: React.language("member.delete.success")
                                    })
                                    this.RefreshList()
                                }).catch(res => {

                                })
                            }
                        })
                    }
                })
            } else if (item.category === 2) {
                menu.push({
                    text: React.language('deactivate'),
                    colorType: "",
                    click: () => {
                        const { _id } = item;
                        BsyAlert({
                            title: React.language("deactivate.alert.tip"),
                            msg: React.language("deactivate.alert.tip1"),
                            type: "query",
                            text4Ok: React.language("deactivate"),
                            OkType: "red",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                React.axios('/corp/member/batch_recover', {
                                    member_id_list: [_id]
                                }).then(res => {
                                    this.RefreshList()
                                }).catch(res => {

                                })
                            }
                        })
                    }
                });
                window.FX.STATIC.user_corps.mode === "common" && menu.push({
                    text: React.language('switch.to.resignation'),
                    colorType: "red",
                    click: () => {
                        const { _id } = item;
                        BsyAlert({
                            title: React.language("dismission.alert.tip"),
                            msg: React.language("dismission.alert.tip1"),
                            type: "query",
                            text4Ok: React.language("confirm"),
                            OkType: "red",
                            text4Cancel: React.language("cancel"),
                            ok: () => {
                                React.axios('/corp/member/dismission', {
                                    members: [_id]
                                }).then(res => {
                                    this.RefreshList()
                                }).catch(res => {

                                })
                            }
                        })
                    }
                });
                menu.push({
                    text: React.language('outsider.member.from.dept'),
                    colorType: "",
                    click: () => {
                        this._createChangOutsiderBubble(item._id);
                    }
                })
            }
            BsyAlertMenu({
                item: menu,
                width: 140,
                target: event.target
            })
        } else if (event.target.classList[1] === "again") {
            const mobile = item.phone
            // if (!mobile) {
            //     tipAlert({
            //         type: "warning",
            //         msg: React.language("Invited.tip1")
            //     })
            //     return;
            // }
            if(BsyUtils.isCommon())
                this.againAllInvite(item._id)

        } else {
            item["mode"] = "resign"
            BsyAlertListDetail({
                ...item,
                departments: this.state.departments,
                onReList: () => {
                    this.RefreshList()
                }
            })
            document.getElementsByTagName('body')[0].style.overflow = "hidden"
        }


    }

    againAllInvite = (mobile) => {
        if(!BsyUtils.isCommon()) {
            return
        }
        // BsyAlert({
        //     title: mobile ? React.language("Invited.tip2", { mobile: mobile }) : React.language("Invited.all.tip"),
        //     msg: "",
        //     type: "query",
        //     text4Ok: React.language("ok"),
        //     text4Cancel: React.language("cancel"),
        //     OkType: "blue",
        //     ok: function () {
        React.axios('/corp/member/reinvite', {
            // mobile: !mobile ? "all" : mobile
            memberIds: BsyUtils.isObjectEmpty(mobile) ? [] : [mobile]
        }).then(res => {
            tipAlert({
                type: "success",
                msg: React.language("Invited.tip3")
            })
        }).catch(res => {
            tipAlert({
                type: "error",
                msg: React.language("member.invite.error.tip")
            })


            // window.FX.Vip.showUpgradeTip(res.data.responseJSON)
        })
        // }
        // })
    }

    handleUserOrder = (data) => {
        React.axios('/corp/member/sort', data).then(res => {

        }).catch(res => {

        })
    }

    render() {
        const { userCont, limit, skip } = this.state;
        const editName = window.FX.STATIC.user_corps.mode !== "qyweixin" && window.FX.STATIC.user_corps.mode !== "dingding" && window.FX.STATIC.user_corps.mode !== "feishu"
        const sync = window.FX.STATIC.user_corps.mode === "qyweixin" || window.FX.STATIC.user_corps.mode === "dingding" || window.FX.STATIC.user_corps.mode === "feishu"

        let list = [{
            width: 225,
            key: "nickname",
            value: React.language("name"),

        }, {
            width: 225,
            key: "uniqueid",
            value: React.language("enterprise.user.id"),
            tooltip: !0 ? React.language("enterprise.tip") : React.language("enterprise.tip1")
        }, {
            width: 225,
            key: "leave_time",
            value: React.language("resign.time")
        }, {
            width: 225,
            key: "role",
            value: React.language("role"),

        }]
        return (
          <div className="user">
              <div className="user-content">
                  <div className="userTitle">
                      <div className="leftUserCont">
                          <div className="title">
                              {

                                  window.FX.STATIC.user_corps.mode && window.FX.STATIC.user_corps.mode === "common" ?
                                    React.language('resign.user') : React.language('resign.user.1')
                              }
                          </div>
                          {userCont.qywx_bind_tip && userCont.has_name_modify && window.FX.STATIC.user_corps.mode === "qyweixin" && window.FX.STATIC.user_corps.isCorpOwn &&
                            <div className="userTip">
                                <i className="icon-bsy-laba">

                                </i>
                                <span>
                                    {React.language('weChat.contacts.auth.tip')}
                                </span>
                                <button>
                                    {React.language('vip.pack.order.ok')}
                                </button>
                            </div>}
                      </div>
                  </div>
                  <div className="userFunBtn">
                      <div className="btnCont">
                          {
                              !BsyUtils.isCommon() ? '' : <BsyIconBtn
                                text={React.language('reinstatement')}
                                iconName="icon-bsy-iconquanbuchengyuan"
                                type="white"
                                hoverType="borderBlue"
                                click={() => {
                                    this.recover(this.tableValue.state.checkList)
                                }}
                                mode={window.mode}
                              />
                          }

                      </div>
                      <div className="searchCont">
                          <BsySearchInput
                            placeholder={React.language('member.search1')}
                            styleInput={{
                                'width': '200px',
                                height: '32px',
                                lineHeight: '30px'
                            }}
                            getValue={this.getSearchValue}
                            onSearch={this.onSearch}
                            type={window.mode}
                            // iconName="icon-bsy-reportmenu-0"
                          />
                      </div>
                  </div>
                  {userCont.users &&
                    <BsyTableList
                      getValue={this.getTableValue}
                      limit={limit}
                      skip={skip}
                      skipChange={this.skipChange}
                      listLimitChange={this.listLimitChange}
                      deptRefresh={this.deptRefresh}
                      listFilterChange={this.listFilterChange}
                      styleType={window.mode}
                      userCont={userCont}
                      count={userCont.count}
                      hasTurnPage={!!userCont.count}
                      list={list}
                      noDarg={true}
                      onRowClick={(e, node) => {
                          this.memberRowClick(e, node)
                      }}
                    />}
              </div>
          </div>
        );
    }
}

export default BsyResignCont;